import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import Alert from '@material-ui/lab/Alert'
import {
  extendPublicStream,
  PublicStreamExtended,
} from '../../api/StreamExtended'
import { usePublicProject } from '../PublicProjectWrapper'
import { VideoPlayerPublicHLS } from './VideoPlayerPublicHLS'
import { FourOhFour } from '../FourOhFourPage'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      minHeight: '100vh',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#000',
      '& video': {
        display: 'block',
      },
    },
    alert: {
      borderRadius: 0,
      border: '1px solid #000',
      borderTopWidth: 0,
      fontWeight: 'bold',
      boxSizing: 'border-box',
    },
    videoContainer: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    player: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  })
)

export const StreamPagePublic = () => {
  const classes = useStyles()
  const project = usePublicProject()
  const { streamName } = useParams<{ streamName: string }>()

  const stream: PublicStreamExtended | undefined = useMemo(() => {
    if (!streamName || !project.streams) return undefined

    const foundStream = project.streams.find(
      (s) => s.source_stream_name === streamName && s.url && s.live === true
    )

    return foundStream ? extendPublicStream(foundStream, project) : undefined
  }, [project, streamName])

  // If stream not found, show 404
  if (!stream) {
    return <FourOhFour />
  }

  return (
    <div className={classes.root}>
      {project && project.live === false ? (
        <Alert severity="warning" className={classes.alert}>
          Live streams not available at the moment.
        </Alert>
      ) : (
        <div className={classes.videoContainer}>
          <VideoPlayerPublicHLS
            stream={stream}
            className={classes.player}
            parentWidth={window.innerWidth}
            extraControls={{
              play: true,
              fullScreen: true,
            }}
            reserveNavSpace={false}
          />
        </div>
      )}
    </div>
  )
}
